<template>
  <div class="border__container">
    <div class="border__field" v-if="customWidth">
      <div class="border__label">{{ $t("ct-border-size") }}</div>
      <div class="align-self-center">
        <input
          type="number"
          min="0"
          class="form-control"
          v-model="bt"
          @change="changeValue"
        />
      </div>
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          position-relative
        "
      >
        <input
          type="number"
          min="0"
          class="form-control"
          v-model="bl"
          @change="changeValue"
          :disabled="linked"
        />
        <div class="my-3 mx-auto border">
          <button
            class="btn p-1"
            :class="[linked ? 'btn-danger' : 'btn-primary']"
            @click="linkWidth"
          >
            <i class="svg-icon svgi-link m-0"></i>
          </button>
        </div>
        <input
          type="number"
          min="0"
          class="form-control"
          v-model="br"
          @change="changeValue"
          :disabled="linked"
        />
      </div>
      <div class="align-self-center">
        <input
          type="number"
          min="0"
          class="form-control"
          v-model="bb"
          @change="changeValue"
          :disabled="linked"
        />
      </div>
    </div>

    <div class="border__field" v-else>
      <div class="border__label">{{ $t("ct-border-size") }}</div>
      <input-range
        class="border__number-control"
        v-model="value"
        @change="changeValue"
      />
    </div>
    <div class="border__field">
      <div class="border__label">{{ $t("ct-border-color") }}</div>
      <color-picker-component ref="colorPicker" class="border__color-control" />
    </div>
    <div class="border__field">
      <div class="border__label">{{ $t("ct-border-shape") }}</div>
      <div class="border__select-control">
        <div
          class="border__select-control--selected solid"
          @click="borderOptionsIsOpen = !borderOptionsIsOpen"
        >
          <div
            class="border__select-control--border"
            :style="{ borderBottomStyle: value2 }"
          ></div>
          <font-awesome-icon icon="caret-down" />
        </div>
        <div
          class="border__select-control--options"
          :class="{ 'is-active': borderOptionsIsOpen }"
          v-if="borderOptionsIsOpen"
        >
          <div
            class="border__select-control--option"
            v-for="o in options.filter((o) => o !== value2)"
            :key="o"
            @click="setBorderStyle(o)"
          >
            <div
              class="border__select-control--border"
              :style="{ borderBottomStyle: o }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorPickerComponent from "./Abstract/ColorPicker";
import InputRange from "./Abstract/InputRange";

export default {
  name: "BorderComponent",
  components: { ColorPickerComponent, InputRange },
  data() {
    return {
      options: ["none", "dotted", "dashed", "solid", "double"],
      element: null,
      value: "",
      value2: "",
      value3: "",
      bt: "",
      bb: "",
      bl: "",
      br: "",
      labelDesc: "ct-border",
      callback: null,
      min: 0,
      max: 100,
      borderOptionsIsOpen: false,
      linked: false,
    };
  },
  props: { customWidth: { type: Boolean, default: false } },
  methods: {
    linkWidth() {
      this.linked = !this.linked;

      this.changeValue();
    },
    changeValue() {
      if (this.bt < this.min) this.bt = this.min;
      if (this.bt > this.max) this.bt = this.max;
      if (this.br < this.min) this.br = this.min;
      if (this.br > this.max) this.br = this.max;
      if (this.bb < this.min) this.bb = this.min;
      if (this.bb > this.max) this.bb = this.max;
      if (this.bl < this.min) this.bl = this.min;
      if (this.bl > this.max) this.bl = this.max;

      if (this.linked) {
        this.bt = this.bt;
        this.br = this.bt;
        this.bb = this.bt;
        this.bl = this.bt;
      }

      document.body.style.setProperty(
        "--border-width-example",
        `${this.bt}px ${this.br}px ${this.bb}px ${this.bl}px`
      );
      document.body.style.setProperty(
        "--border-example",
        `${this.value}px ${this.value2} ${this.value3}`
      );

      if (this.value < this.min) this.value = this.min;
      let response = {
        size: this.value,
        style: this.value2,
        color: this.value3,
        width: `${this.bt}px ${this.br}px ${this.bb}px ${this.bl}px`,
      };
      this.callback(response);
    },
    setValues(obj) {
      let vm = this;

      if (typeof obj.defaultValue === "undefined") {
        obj.defaultValue = "0 none #000000";
      }

      let value = obj.defaultValue.split(" ");

      this.value = parseInt(value[0]);
      this.value2 = value[1];
      this.value3 = value[2];

      this.min = parseInt(obj.min);
      this.max = parseInt(obj.max);
      this.element = obj.element;
      this.labelDesc = obj.labelDesc
        ? this.$t(`ct-${obj.labelDesc}`)
        : this.$t(`ct-border`);
      this.callback = obj.callback;

      let newObj = Object.assign({}, obj);
      newObj.defaultValue = value[2];
      newObj.callback = (value) => {
        vm.value3 = value;
        vm.changeValue();
      };
      this.$refs.colorPicker.setValues(newObj);

      if (this.customWidth) {
        let width = [];
        if (typeof obj.borderWidth !== "undefined") {
          width = obj.borderWidth.split(" ");
        }

        this.bt = parseInt(width[0]) || this.value;
        this.br = parseInt(width[1]) || this.value;
        this.bb = parseInt(width[2]) || this.value;
        this.bl = parseInt(width[3]) || this.value;

        if (this.bt == this.br && this.bt == this.bl && this.bt == this.bb) {
          this.linked = true;
        }

        document.body.style.setProperty(
          "--border-width-example",
          `${this.bt}px ${this.br}px ${this.bb}px ${this.bl}px`
        );
        document.body.style.setProperty("--border-example", obj.defaultValue);
      }
    },
    setBorderStyle(style) {
      this.value2 = style;
      this.borderOptionsIsOpen = false;
      this.$nextTick(() => this.changeValue());
    },
  },
};
</script>

<style lang="sass" scoped>
.border__container
  display: flex
  flex-direction: column
  padding: 0 15px
  margin-bottom: 30px

  .border__field
    display: flex
    flex-direction: column
    margin-bottom: 17px

    .form-control
      width: 65px

    .my-3
      width: 90px
      height: 90px
      border: var(--border-example) !important
      border-width: var(--border-width-example) !important
      .btn
        min-height: 5px
        height: min-content
        top: 47px
        left: 113px
        position: absolute
        .svg-icon
          filter: brightness(5)

    .border__label
      font: normal normal 600 13px/14px Muli
      color: #5A5959
      margin-bottom: 15px

    .border__select-control
      position: relative

      .border__select-control--selected
        display: flex
        align-items: center
        background: #FAFBFC
        border: 1px solid #DDDDDD
        border-radius: 3px
        padding: 0 20px
        height: 37px
        cursor: pointer

        &:not(:last-child)
          border-radius: 3px 3px 0 0

        svg
          margin-left: 20px

      .border__select-control--options
        transition: all 1s
        border: 1px solid #DDDDDD
        border-top: 0
        border-radius: 0 0 3px 3px
        background: #FFFFFF
        position: absolute
        width: 100%
        z-index: 999

        .border__select-control--option
          height: 40px
          display: flex
          align-items: center
          padding: 0 20px
          cursor: pointer
          transition: background-color 300ms

          &:hover
            background: #F4F4F4

      .border__select-control--border
        border-bottom: 4px solid #707070
        flex: 1
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Border.vue